module.exports = __webpack_public_path__ + "static/media/ic-landing-attitude.17e83811.png";